// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__I65bz","title":"Modal_title__nr2fG","actions":"Modal_actions__3V0Qu","cancelButton":"Modal_cancelButton__3eqQT","submitButton":"Modal_submitButton__1UZbT"};